<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <p-calendar
        [id]="inputId"
        [name]="name"
        [formControlName]="name"
        [showIcon]="true"
        appendTo="body"
        [dateFormat]="dateFormat"
        (onSelect)="onDateSelected($event)"
        [minDate]="minDate"
        [maxDate]="maxDate"
    ></p-calendar>
</hvl-form-item>
